export default __webpack_public_path__ + "static/media/1836.3d764d8a.png";